import { Controller } from "@hotwired/stimulus"
import $ from 'jquery';
import Channels from 'channels'

export default class extends Controller {
  static targets = []
  static values = {
    channel: String,
    recordId: Number,
    url: String,
    processing: {type: Boolean, default: true}
  }

  connect() {
    let id = this.element.id
    if(!this.hasChannelValue) {
      console.error('channel not defined')
      return
    }
    let channel = Channels[this.channelValue]
    if(!channel) {
      console.error('channel not found: "%s"', this.channelValue)
      return
    }
    channel(this.recordIdValue, ({status, ...rest})=>{
      console.log(this.processingValue)
      if(status == 'processing') {
        if(this.processingValue) {
          this.element.querySelector('.loading-mask')?.classList.remove('hide')
          this.element.querySelector('.panel')?.classList.add('hide')
        }
      } else {
        let promise = $.get(this.urlValue)
        promise.done((responseText)=>{
          this.element.innerHTML = $('<div>').append($.parseHTML(responseText)).find(`#${id}`).html()
          $(document).foundation()
          this.element.querySelector('.loading-mask')?.classList.add('hide')
          this.element.querySelector('.panel')?.classList.remove('hide')
        });
      }
    })
  }
};
